function BaseError(...opts) {
    const error = Error.call(this, ...opts);

    this.message = error.message;
    // 1. .stack is a getter in V8; it's only calculated when asked for.  Errors go way
    // faster if we skip this.
    // 2. but it sure is nice to have stack available!
    // 3. but the only thing we're currently doing with extensible errors is instanceof
    // checks, for which don't need a stack.
    //
    // this.stack = error.stack;
}

BaseError.prototype = Object.create(Error.prototype);
BaseError.prototype.constructor = BaseError;

export {
    BaseError,
};
